import React, { useContext, useState } from "react";
import "./LoginCard.css";
import LoginButton from "../loginButton/LoginButton.js";
import TextField from "@mui/material/TextField";
import LoginImage from "../../images/Login_image.png";
import Card from "@mui/material/Card";
import { useNavigate } from "react-router";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Input from "@mui/material/Input";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import { AuthContext } from "../../context/AuthContext.js";

const LoginCard = () => {
  const { dispatch } = useContext(AuthContext);
  const [userError, setUserError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [Username, setUsername] = useState("");
  const [Password, setPassword] = useState("");
  const navigation = useNavigate();
  const [userDetails, setUserDetails] = useState("");

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const onUsernameChange = (event) => {
  setUsername(event.target.value);
};

const onPasswordChange = (event) => {
  setPassword(event.target.value);
};
  const submitFunction = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username: Username, password: Password }),
    };

    fetch(`${process.env.REACT_APP_BASE_URL}/api/auth/login`, requestOptions)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setUserDetails(data);
        if (data) {
          localStorage.setItem("jwt", data.token);
          localStorage.setItem("role", data.role);
          localStorage.setItem("employeeId", data.employeeId);
          localStorage.setItem("departmentId", data.departmentId);
          dispatch({ type: "LOGIN_SUCCESS", payload: data.role });

          if (data.role === "HOD") {
            navigation("/hod");
          } else if (data.role === "ADMIN") {
            navigation("/admin");
          } else if (data.role === "REPRESENTATIVE" && data.departmentId === "AUTONOMOUS"){
            navigation("/autonomous")
          } else if (data.role === "REPRESENTATIVE" && data.departmentId === "PLACEMENT"){
            navigation("/placement")
          } else if (data.role === "REPRESENTATIVE" && data.departmentId === "PA"){
            navigation("/pa")
          } else if (data.role === "REPRESENTATIVE" && data.departmentId === "ACADEMIC"){
            navigation("/academic")
          } else if (data.role === "REPRESENTATIVE" && data.departmentId === "COE"){
            navigation("/coe")
          } else if (data.role === "REPRESENTATIVE" && data.departmentId === "IQAC"){
            navigation("/dean")
          }  else if (data.role === "REPRESENTATIVE" && data.departmentId === "NSS"){
            navigation("/nss")
          }  else if (data.role === "REPRESENTATIVE" && data.departmentId === "NCC"){
            navigation("/ncc")
          }
          else if (data.role === "REPRESENTATIVE" && data.departmentId === "PED"){
            navigation("/ped")
          }
          else if (data.role === "REPRESENTATIVE" && data.departmentId === "ADMINISTRATOR"){
            navigation("/administrator")
          }
          else if (data.role === "REPRESENTATIVE" && data.departmentId === "IIC"){
            navigation("/iic")
          }
          else if(data.role === "REPRESENTATIVE" && data.departmentId === "ACCOUNT"){
            navigation("/account")
          }
          else if(data.role === "REPRESENTATIVE" && data.departmentId === "PSGII - TRAINING DEPT"){
            navigation("/psgtraining")
          }
          else if(data.role === "REPRESENTATIVE" && data.departmentId === "ALUMNI ASSN"){
            navigation("/alumini")
          }
        }
      })
      .catch((error) => {
        console.error("Error during login:", error);
        setUserError(true);
        setPasswordError(true);
      });
  };

  const handleForgotPassword = () => {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("jwt")} `,
      },
      body: JSON.stringify({ email: Username}),
    };
    fetch(`${process.env.REACT_APP_BASE_URL}/api/auth/forgot-password`,requestOptions)
    .then(async (response) => {
      const data = await response.json();
      if (response.ok) {
        window.alert("Reset email sent successfully.");
      } else {
        window.alert(data.error || "Failed to send reset email.");
      }
    })
    .catch((error) => {
      console.error("Error:", error);
      window.alert("An error occurred while sending the reset email.");
    });
  };

  return (
    <>
      <div className="login">
        <Card variant="outlined" className="form">
          <TextField
            error={userError}
            required
            value={Username}
            id="standard-basic"
            label="Username"
            variant="standard"
            onChange={onUsernameChange}
            sx={{ marginBottom: "25px" }}
          />
          {/* <TextField
            id="standard-basic"
            label="Password"
            variant="standard"
            type="password"
            onChange={onPasswordChange}
            sx={{ marginBottom: "32px" }}
          /> */}
          <FormControl
            sx={{ m: 1, width: "25ch" }}
            error={passwordError}
            required
            variant="standard"
          >
            <InputLabel htmlFor="standard-adornment-password">
              Password
            </InputLabel>
            <Input
              value={Password}
              onChange={onPasswordChange}
              id="standard-adornment-password"
              type={showPassword ? "text" : "password"}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
          <LoginButton name="Log In" submit={submitFunction} />
          <div style={{ marginTop: '10px', textAlign: 'center' }}>
            <span
              onClick={handleForgotPassword}
              style={{ textDecoration: 'none', color: '#1976d2', cursor: 'pointer' }}
            >
              Forgot Password?
            </span>
          </div>
        </Card>
        <div className="login-img">
          <img src={LoginImage} alt="Login-Image" width="500" height="500" />
        </div>
      </div>
    </>
  );
};

export default LoginCard;
